import actions from './actions';
import mutations from './mutations';
import getters from './getters';

export default {
  state: {
    budUrl: "https://bud.apps.det.nsw.edu.au",
    budToken: "r32NugWxhwob4niMr9IvGb2IYf1JtJjl",
    links: {
      wan: {in: [], out: [], loading: false, error: null, errorMessage: null},
      internet: {in: [], out: [], loading: false, error: null, errorMessage: null},
      bandwidth: { wan_bw:0, int_bw:0, loading: false, error: null, errorMessage: null }
    }
  },
  actions,
  getters,
  mutations,
}
